module.exports = __webpack_public_path__ + "static/media/approved.20ed7f66.png";